import clsx from 'clsx';
import { KeyboardEvent, MouseEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { KeyCode } from '@vestico/utils';

import { SkinTypeOption, skinTypeTitle } from '@vestico/model';

import { SVGImage } from '../SVGImage';
import style from './SkinTypeSelectOption.module.css';

export interface SkinTypeSelectOptionProps {
  option: SkinTypeOption;
  selected?: boolean;
  didUpdateConfig: () => void;
}

export const SkinTypeSelectOption = ({ option, selected, didUpdateConfig }: SkinTypeSelectOptionProps) => {
  const { image } = option;
  const { t } = useTranslation('model');
  const [useTabIndex, setUseTabIndex] = useState(true);

  const handleKeyUp = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.code === KeyCode.enter) {
        setUseTabIndex(false);
        didUpdateConfig();
      }
    },
    [didUpdateConfig]
  );

  const onClick = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      setUseTabIndex(false);
      didUpdateConfig();
    },
    [didUpdateConfig]
  );

  return (
    <div className={clsx(style.root, { [style.selected]: selected })}>
      {/* WORKAROUND: For some unknown reason we cannot add 'tabIndex' statically here as it'll break the animation */}
      <div className={clsx(style.container)} onClick={onClick} onKeyUp={handleKeyUp} role="button" tabIndex={useTabIndex ? 0 : undefined}>
        <div className={clsx(style.image)}>
          <SVGImage name={image} showSpinner />
        </div>
        <div>{skinTypeTitle(option.id, t)}</div>
      </div>
    </div>
  );
};
